export default __webpack_public_path__ + "static/media/Back.41a00f3c.png";